module.exports = __webpack_public_path__ + "img/calculator-illustration-1.f5d21415.png";